import { getScrollBar } from '../lib/_tool.js';
import { loadResources } from '../lib/_preload.js';
import { loadingProgress, isDetail, getPageCategory, setURLtoPager } from '../page/_page_tools.js';
import { autoPlayVimeo } from '../lib/_vimeo.js';
import { showMorePost } from '../lib/_more.js';
import { kvSlide } from '../lib/_kv.js';
import { reActive } from './_pushstate.js';

const $html = document.documentElement;

export let modalDetailPage = {
	currentPageCategory: "",
	detailModal: null,
	detailContent: null,
	beforePage: "",
	init: function(){
		const hasDetailFolder = ['works', 'people', 'magazine', 'news'];
		modalDetailPage.currentPageCategory = document.querySelector("body").getAttribute("data-page-category");
		if( hasDetailFolder.includes( modalDetailPage.currentPageCategory ) ){
			modalDetailPage.detailModal	 	= document.querySelector("[data-page-detail]");
			modalDetailPage.detailContent 	= modalDetailPage.detailModal.querySelector(`[data-content]`);
		}
		if( document.documentElement.classList.contains("show_detail") ){
			modalDetailPage.afterOpen();
		}
	},
	resize: function(){
		getScrollBar();
		setTimeout(function(){
			getScrollBar();
		},300);
	},
	getContent: function(){
		//console.log("modal detail get content");
		let $html = document.documentElement;
		let $body = document.querySelector("body");
		let isDetailPage = true;
		loadingProgress(0, isDetailPage);
		if( !$body.classList.contains("load_detail") ){
			$body.classList.add("load_detail");
			loadingProgress(25, isDetailPage);
			let url = location.pathname;
			fetch(url).then(response => response.text()).then(html => {
				const tempDiv 		= document.createElement('div');
				tempDiv.innerHTML 	= html;
				const title 		= tempDiv.querySelector("title").innerText;
				document.title 		= title;
				const targetElement = tempDiv.querySelector(`[data-content]`);
				//console.log(targetElement);
				document.querySelector("[data-content]").innerHTML = targetElement.innerHTML;
				loadingProgress(50, isDetailPage);
				//console.log(tempDiv);
				//pager
				modalDetailPage.currentPageCategory = getPageCategory();
				if( modalDetailPage.currentPageCategory === "works" || modalDetailPage.currentPageCategory === "people" || modalDetailPage.currentPageCategory === "news" || modalDetailPage.currentPageCategory === "magazine" ){
					//pager
					let nextURL = tempDiv.querySelector(`a[data-nav-next]`).getAttribute("href");
					let prevURL = tempDiv.querySelector(`a[data-nav-prev]`).getAttribute("href");
					if( modalDetailPage.currentPageCategory === "magazine" ){
						let urls = getNextPrevURL();
						nextURL = urls[1];
						prevURL = urls[0];
					}
					setURLtoPager(nextURL, prevURL);
				}
				
				modalDetailPage.loadImages(targetElement).then( ()=> {
					$body.classList.remove("load_detail");
					modalDetailPage.open();
				});
			})
			.catch(error => console.error('Error:', error));
		}
	},
	loadImages: function(element){
		let $body 	= document.querySelector("body");
		let imgs 	= element.querySelectorAll(".imgs img");
		let imgArry = [];
		return new Promise( (resolve, reject) => {
			imgs.forEach( ($img, index) => {
				let src = $img.getAttribute("src");
				if( src && src != "" && !$img.complete){
					if(index < 10){
						imgArry.push( $img );
					}
				}
			});
			if(imgArry.length > 0){
				loadResources( imgArry ).then( ()=> {
					endLoading();
				});
			}else{
				endLoading();
			}
			function endLoading(){
				loadingProgress(100, true);
				setTimeout(function(){
					resolve();
				}, 200);
			}
		});
	},
	open: function(){
		let $inner = document.querySelector(".b-detail_inner");
		$inner.scrollTo(0, 0);
		if( !$html.classList.contains("show_detail") ){
			$html.classList.remove("load_detail");
			$html.classList.add("no_scroll");
			setTimeout( function(){
				$html.classList.add("show_detail");
				modalDetailPage.resize();
				modalDetailPage.afterOpen();
			}, 50);
		}else{
			if( modalDetailPage.detailModal.classList.contains("change_detail") ){
				$html.classList.remove("load_detail");
				modalDetailPage.detailModal.classList.remove("change_detail");
				modalDetailPage.afterOpen();
			}
		}
	},
	close: function(){
		let $target = document.querySelector("[data-page-detail]");
		if( $html.classList.contains("show_detail") ){
			$html.classList.remove("show_detail");
			document.title 	= document.querySelector("main").getAttribute("data-page-title"); 
			modalDetailPage.resize();
			$target.addEventListener("transitionend", modalDetailPage.endClose, {
				once: true
			});
		}
	},
	back: function(){
		let url 	= location.pathname;
		
		console.log(modalDetailPage.beforePage)
		let arry 	= url.split("/");
		let path 	= `/${arry[1]}/`;
		let state 	= { page_id: path };
		history.pushState(state, "", path);
	},
	afterOpen: function(){
		console.log("after open detail page");
		kvSlide.init();
		modalDetailPage.activeFunc();
		let $loading = document.querySelector("#loading");
		let $loading2 = document.querySelector(".c-loading_detail");
		if( $loading.classList.contains("r") ){
			$loading.classList.remove("r");
		}
		loadingProgress(0, false);
		if( $loading2 ){
			loadingProgress(0, true);
			if( $loading2.classList.contains("r") ){
				$loading2.classList.remove("r");
			}
		}
		/*
		if( modalDetailPage.currentPageCategory === "magazine" ){
			let urls = getNextPrevURL();
			nextURL = urls[1];
			prevURL = urls[0];
			setURLtoPager(nextURL, prevURL);
		}
		*/
	},
	activeFunc: function(){
		autoPlayVimeo.init();
		
		showMorePost.nav();
		reActive.nav();
	}
}
let getNextPrevURL = ()=> {
	let $list = document.querySelectorAll(".c-list-magazine_summaries ul li a");
	let urls = [];
	let current = location.pathname;
	let currentIndex = 0;
	let count = 0;
	$list.forEach( ($post, index) => {
		let url = $post.getAttribute("href");
		if( url != "/magazine/?tag=wednesday_kitchen"){
			if( url === current){
				currentIndex = count;
			}
			urls.push( $post.getAttribute("href"));
			count++;
		}
	});
	let prevIndex = currentIndex - 1;
	prevIndex = prevIndex < 0 ? urls.length - 1 : prevIndex;
	let nextIndex = currentIndex + 1;
	nextIndex = nextIndex >= urls.length ? 0 : nextIndex;
	let arry = [urls[prevIndex], urls[nextIndex]];
	console.log(urls);
	console.log(arry);
	return arry;
};